export const getHeatmapPM2_5 = (radius = 20) => {
  return ({
    id: "p534sqa",
    type: "heatmap",
    config: {
      dataId: "pm2_5",
      label: "heatmap",
      color: [179, 173, 158],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer Blues-6",
          type: "singlehue",
          category: "ColorBrewer",
          colors: [
            "#d1c4e9",
            "#9575cd",
            "#7e57c2",
            "#673ab7",
            "#512da8",
            "#4527a0",
            '#311b92'
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: "PM2.5",
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: "PM2.5",
        type: "real",
      },
      weightScale: "linear",
    },
  })
}

export const heatmapPM2_5Norm = {
  id: "p534sqa",
  type: "heatmap",
  config: {
    dataId: "pm2_5",
    label: "heatmap",
    color: [179, 173, 158],
    highlightColor: [252, 242, 26, 255],
    columns: {
      lat: "lat",
      lng: "lon",
    },
    isVisible: true,
    visConfig: {
      opacity: 0.8,
      colorRange: {
        name: "ColorBrewer Blues-6",
        type: "singlehue",
        category: "ColorBrewer",
        colors: [
          "#d1c4e9",
          "#9575cd",
          "#7e57c2",
          "#673ab7",
          "#512da8",
          "#4527a0",
          '#311b92'
        ],
      },
      radius: 15,
    },
    hidden: false,
    weightField: {
      name: 'data_norm',
      type: "real",
    },
    textLabel: [
      {
        field: null,
        color: [255, 255, 255],
        size: 18,
        offset: [0, 0],
        anchor: "start",
        alignment: "center",
      },
    ],
  },
  visualChannels: {
    weightField: {
      name: 'data_norm',
      type: "real",
    },
    weightScale: "linear",
  },
}

export const getHeatmapPM2_5Norm = (radius=25)=>{
  return {
    id: "p534sqa",
    type: "heatmap",
    config: {
      dataId: "pm2_5",
      label: "heatmap",
      color: [179, 173, 158],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer Blues-6",
          type: "singlehue",
          category: "ColorBrewer",
          colors: [
            "#d1c4e9",
            "#9575cd",
            "#7e57c2",
            "#673ab7",
            "#512da8",
            "#4527a0",
            '#311b92'
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: 'data_norm',
        type: "real",
      },
      weightScale: "linear",
    },
  }
}


export const getHeatmapPM10 = (radius = 25) => {
  return ({
    id: "p534sqa",
    type: "heatmap",
    config: {
      dataId: "pm10",
      label: "heatmap",
      color: [179, 173, 158],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer Blues-6",
          type: "singlehue",
          category: "ColorBrewer",
          colors: [
            "#EDD1CA",
            "#C99DA4",
            "#A6758E",
            "#83537C",
            "#573660",
            "#2C1E3D"
          ],
          reverse: true,
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: "PM10",
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: "PM10",
        type: "real",
      },
      weightScale: "linear",
    },
  })
}

export const heatmapPM10Norm = {
  id: "p534sqa",
  type: "heatmap",
  config: {
    dataId: "pm10",
    label: "heatmap",
    color: [179, 173, 158],
    highlightColor: [252, 242, 26, 255],
    columns: {
      lat: "lat",
      lng: "lon",
    },
    isVisible: true,
    visConfig: {
      opacity: 0.8,
      colorRange: {
        name: "ColorBrewer Blues-6",
        type: "singlehue",
        category: "ColorBrewer",
        colors: [
          "#EDD1CA",
          "#C99DA4",
          "#A6758E",
          "#83537C",
          "#573660",
          "#2C1E3D"
        ],
        reverse: true,
      },
      radius: 15,
    },
    hidden: false,
    weightField: {
      name: "data_norm",
      type: "real",
    },
    textLabel: [
      {
        field: null,
        color: [255, 255, 255],
        size: 18,
        offset: [0, 0],
        anchor: "start",
        alignment: "center",
      },
    ],
  },
  visualChannels: {
    weightField: {
      name: "data_norm",
      type: "real",
    },
    weightScale: "linear",
  },
}

export const getHeatmapPM10Norm = (radius=25) => {
  return {
    id: "p534sqa",
    type: "heatmap",
    config: {
      dataId: "pm10",
      label: "heatmap",
      color: [179, 173, 158],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer Blues-6",
          type: "singlehue",
          category: "ColorBrewer",
          colors: [
            "#EDD1CA",
            "#C99DA4",
            "#A6758E",
            "#83537C",
            "#573660",
            "#2C1E3D"
          ],
          reverse: true,
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: "data_norm",
        type: "real",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: "data_norm",
        type: "real",
      },
      weightScale: "linear",
    },
  }
}

export const heatmapCO2 = {
  id: "qt2o0q9",
  type: "heatmap",
  config: {
    dataId: "CO2",
    label: "heatmap",
    color: [231, 159, 213],
    highlightColor: [252, 242, 26, 255],
    columns: {
      lat: "lat",
      lng: "lon",
    },
    isVisible: true,
    visConfig: {
      opacity: 0.8,
      colorRange: {
        name: "Uber Viz Sequential 4",
        type: "sequential",
        category: "Uber",
        colors: [
          // "#ffffcc",
          // "#d9f0a3",
          // "#addd8e",
          // "#78c679",
          // "#31a354",
          // "#006837",
          "#f7f7f7",
          "#d9d9d9",
          "#bdbdbd",
          "#969696",
          "#636363",
          "#252525",
        ],
      },
      radius: 15,
    },
    hidden: false,
    weightField: { name: "Co2", type: "real" },
    textLabel: [
      {
        field: null,
        color: [255, 255, 255],
        size: 18,
        offset: [0, 0],
        anchor: "start",
        alignment: "center",
      },
    ],
  },
  visualChannels: {
    weightField: {
      name: "Co2",
      type: "real",
    },
    weightScale: "linear",
  },
};

export const heatmapCO2Norm = {
  id: "qt2o0q9",
  type: "heatmap",
  config: {
    dataId: "CO2",
    label: "heatmap",
    color: [231, 159, 213],
    highlightColor: [252, 242, 26, 255],
    columns: {
      lat: "lat",
      lng: "lon",
    },
    isVisible: true,
    visConfig: {
      opacity: 0.8,
      colorRange: {
        name: "Uber Viz Sequential 4",
        type: "sequential",
        category: "Uber",
        colors: [
          // "#ffffcc",
          // "#d9f0a3",
          // "#addd8e",
          // "#78c679",
          // "#31a354",
          // "#006837",
          "#f7f7f7",
          "#d9d9d9",
          "#bdbdbd",
          "#969696",
          "#636363",
          "#252525",
        ],
      },
      radius: 25,
    },
    hidden: false,
    weightField: { name: "data_norm", type: "real" },
    textLabel: [
      {
        field: null,
        color: [255, 255, 255],
        size: 18,
        offset: [0, 0],
        anchor: "start",
        alignment: "center",
      },
    ],
  },
  visualChannels: {
    weightField: {
      name: "data_norm",
      type: "real",
    },
    weightScale: "linear",
  },
};

export const getHeatmapCO2Norm = (radius = 25) => {
  return ({
    id: "qt2o0q9",
    type: "heatmap",
    config: {
      dataId: "CO2",
      label: "heatmap",
      color: [231, 159, 213],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "Uber Viz Sequential 4",
          type: "sequential",
          category: "Uber",
          colors: [
            "#f7f7f7",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#636363",
            "#252525",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: { name: "data_norm", type: "real" },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: "data_norm",
        type: "real",
      },
      weightScale: "linear",
    },
  })
}

export const heatmapCO2Animated = {
  id: "iz6ms1",
  type: "heatmap",
  config: {
    dataId: "CO2",
    label: "heatmap",
    color: [221, 178, 124],
    highlightColor: [252, 242, 26, 255],
    columns: {
      lat: "lat",
      lng: "lon",
    },
    isVisible: true,
    visConfig: {
      opacity: 0.8,
      colorRange: {
        name: "ColorBrewer YlGn-6",
        type: "sequential",
        category: "ColorBrewer",
        colors: [
          "#f7f7f7",
          "#d9d9d9",
          "#bdbdbd",
          "#969696",
          "#636363",
          "#252525",
        ],
      },
      radius: 15,
    },
    hidden: false,
    weightField: {
      name: "Co2",
      type: "integer",
    },
    textLabel: [
      {
        field: null,
        color: [255, 255, 255],
        size: 18,
        offset: [0, 0],
        anchor: "start",
        alignment: "center",
      },
    ],
  },
  visualChannels: {
    weightField: {
      name: "Co2",
      type: "integer",
    },
    weightScale: "linear",
  },
};

export const getHeatmapCO2Animated = (radius = 20) => {
  return ({
    id: "iz6ms1",
    type: "heatmap",
    config: {
      dataId: "CO2",
      label: "heatmap",
      color: [221, 178, 124],
      highlightColor: [252, 242, 26, 255],
      columns: {
        lat: "lat",
        lng: "lon",
      },
      isVisible: true,
      visConfig: {
        opacity: 0.8,
        colorRange: {
          name: "ColorBrewer YlGn-6",
          type: "sequential",
          category: "ColorBrewer",
          colors: [
            "#f7f7f7",
            "#d9d9d9",
            "#bdbdbd",
            "#969696",
            "#636363",
            "#252525",
          ],
        },
        radius: radius,
      },
      hidden: false,
      weightField: {
        name: "Co2",
        type: "integer",
      },
      textLabel: [
        {
          field: null,
          color: [255, 255, 255],
          size: 18,
          offset: [0, 0],
          anchor: "start",
          alignment: "center",
        },
      ],
    },
    visualChannels: {
      weightField: {
        name: "Co2",
        type: "integer",
      },
      weightScale: "linear",
    },
  })
}
